import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { StoreInfo } from '../../core/models';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    'Select Staff': props<{ staffIdx: number }>(),
    'Key Press': props<{ key: string }>(),
    'Set Pin': props<{ pin: string }>(),
    'Verify Pin': emptyProps(),
    'Verify Pin Success': props<{
      token: string;
      accountId: string;
      storeId: string;
      terminalId: string;
      storeInfo: StoreInfo;
      assetName: string;
    }>(),
    'Verify Pin Failure': props<{ error: string }>(),
    'Logout': emptyProps(),
  },
});
